module.exports = __webpack_public_path__ + "static/media/trees.e9399cbe.jpeg";